import * as Icon from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { dateConvert } from "../../utils/Helper";
import { useTeamComposition } from "../../Hooks/Features/ProjectGlance/useTeamComposition";
import { SkeletonContainer } from "../Loader/Loader"

const ProjectInfo = ({ projectId }) => {

    const card = "project_info";
    const { projectInfo, loader } = useTeamComposition({ projectId, card });

    const fields = [
        {
            label: "Project Leads",
            icon: "srkay-users-group",
            key: "project_leads"
        },
        {
            label: "Team Leads",
            icon: "srkay-users-group",
            key: "team_leads"
        },
        {
            label: "Start Date",
            icon: "srkay-calendar",
            key: "project_start_date",
            type: "date"
        },
        {
            label: "End Date",
            icon: "srkay-flag",
            key: "project_end_date",
            type: "date"
        },
    ]

    return (
        <div className="h-100">
            <div className="fs-6 fw-semibold d-flex gap-2 align-items-center p-1 pb-3">
                <FontAwesomeIcon icon={Icon?.faBuilding} />Project Info
            </div>
            <div className="d-flex justify-content-between px-3">
                {loader?.project_info ? <div className="w100" style={{height: "100px"}}><SkeletonContainer/></div> : fields?.map(item => {
                    let obj = {value: projectInfo?.[item?.key]};
                    if(item?.key === "project_leads" || item?.key === "team_leads") {
                        obj.value = obj?.value?.split(", ")?.[0];
                        obj["count"] = projectInfo?.[item?.key]?.split(", ")?.length - 1;
                        obj["tooltip"] = projectInfo?.[item?.key]?.split(", ")?.splice(1)?.join("\n");
                    }
                    return (
                        <div key={item?.key} className="text-center w25">
                            <div className="fw-semibold d-flex gap-1 justify-content-center" style={{ fontSize: "0.9rem" }}>
                                {item?.type === "date" ? (obj?.value ? dateConvert(obj?.value, "day-mon-year") : "-") : obj?.value || "-"}
                                {obj?.count ? <div className="rounded" title={obj?.tooltip} style={{backgroundColor: "#e2e2e2", width: "20px", height: "20px", cursor: "default"}}>+{obj?.count}</div> : ""}
                            </div>
                            <div className="d-flex align-items-center justify-content-center gap-1" style={{ color: "grey" }}>
                                <div className={item?.icon} />
                                <div style={{ fontSize: "0.75rem" }}>{item?.label}</div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default ProjectInfo